import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { Modal, PhoneNumberView } from '@vibrent/electryon';
import styles from './styles.scss';

const BUTTON = {
  VERIFY: 'End CATI',
  CANCEL: 'Cancel',
};

const {
  InformationModal,
} = Modal;


class CATIActiveSessionModal extends Component {
  constructor(props) {
    super(props);
    this.onVerify = this.onVerify.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.hideModal = this.hideModal.bind(this);
  }

  onVerify() {
    this.hideModal();
  }

  getParticipantPlatformId = (participant, fallback) => {
    if (!participant) return fallback;
    const participantId = participant.platformParticipantId;
    return participantId || fallback;
  };

  getParticipantEmail = (participant, fallback) => {
    if (!participant) return fallback;
    const email = participant.email;
    if (email) {
      return email;
    }
    return fallback;
  };

  getParticipantPhone = (participant, fallback) => {
    if (!participant) return fallback;
    const phone = participant.verifiedPrimaryPhoneNumber || participant.phone;
    if (phone) {
      return (<PhoneNumberView
        phoneNumber={phone}
        internationalPhoneSupportEnabled={
          this.props.currentActiveProgram.internationalPhoneSupportEnabled
        }
      />);
    }
    return fallback;
  };

  closeModal() {
    this.props.closeModal();
  }

  hideModal() {
    this.props.hideModal();
  }

  renderModalBody = () => {
    const { participant } = this.props;

    const participantPlatformId = this.getParticipantPlatformId(participant, 'Not Available');
    const participantEmail = this.getParticipantEmail(participant, 'Not Available');
    const participantPhone = this.getParticipantPhone(participant, 'Not Available');

    return (
      <div>
        <p style={{ marginLeft: '-5px' }}>
          {this.props.t(
            'A Previous CATI session is still active for another participant. End it before starting a new one.'
          )}
        </p>

        <p style={{ marginLeft: '-5px' }}>
          {this.props.t(
            'ACTIVE SESSION PARTICIPANT'
          )}
        </p>
        <p>
          {this.props.t('Participant ID : {{getParticipantPlatformId}}', { getParticipantPlatformId: participantPlatformId })}
        </p>
        <p>
          {this.props.t('Email : {{getParticipantEmail}}', { getParticipantEmail: participantEmail })}
        </p>
        <p>
          <p>
            {this.props.t('Phone')} : {participantPhone}
          </p>
        </p>
      </div>
    );
  };

  renderModalFooter() {
    return (<Fragment>
      <Button
        onClick={this.closeModal}
        className="button btn btn-secondary btn-verify"
      >
        {this.props.t(BUTTON.CANCEL)}
      </Button>
      <Button
        className="button button-primary btn btn-primary"
        onClick={this.onVerify}
      >
        {this.props.t(BUTTON.VERIFY)}
      </Button>
    </Fragment>);
  }

  render() {
    const { show, t } = this.props;
    return (
      <InformationModal
        className={styles['cati-modal']}
        show={show}
        onHide={this.closeModal}
        backdrop="static"
        title={t('Active CATI Session')}
        body={this.renderModalBody()}
        footer={this.renderModalFooter()}
      />
    );
  }
}

CATIActiveSessionModal.propTypes = {
  show: PropTypes.bool,
  closeModal: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  currentActiveProgram: PropTypes.shape({
    internationalPhoneSupportEnabled: PropTypes.bool,
  }),
  participant: PropTypes.shape({
    platformParticipantId: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  }),
};

CATIActiveSessionModal.defaultProps = {
  show: false,
  currentActiveProgram: {
    internationalPhoneSupportEnabled: false,
  },
  closeModal: undefined,
  participant: null,
};

export default CATIActiveSessionModal;
